import React from 'react'
import {KitImageWrapper, Image} from '../style'
import {images} from '../../../pages/Homepage/data'

export const KitImage = ({imgID}) =>  {

    return (
        <>
        <KitImageWrapper>
            <Image src={images[imgID]}/>
        </KitImageWrapper>
        </>
    )
}
